var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("i", { staticClass: "material-icons", style: _vm.iconStyle }, [
    _vm._v(_vm._s(_vm.getIcon)),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }